import { ApolloClient, InMemoryCache ,createHttpLink, from} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

const authLink = setContext((_, {headers}) => {
return {
headers: {
    ...headers,
authorization: 'Bearer CODEXAK91EA7D4A317745DA82C6CB52245BF85160307E1363DB4572981CBC926591458F'
}
}
})

const httpLink = createHttpLink({
    uri:'https://graphql.codex.gjirafa.tech/v2/picpay-apidev?siteId=siQUAq2b1W'
})

const errorLink = onError(() => {

})

const client = new ApolloClient({
  cache: new InMemoryCache(),
link:from([errorLink, authLink,httpLink])
});

export default client;
